module.exports = __webpack_public_path__ + "static/youtube-a1474e3bb909685bdfedd3e51e5f9fc4.jpg";